import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/components/Home";
import Charity from "@/components/Charity";
import Admin from "@/components/Admin";

export default function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.2 }}>
      <BrowserRouter>
        <div className="App bg-brand-black text-white font-sans" data-testid="app-root">
          <div className="noise-overlay" aria-hidden="true" />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/where-your-tips-go" element={<Charity />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
          <Toaster position="bottom-center" theme="dark" />
        </div>
      </BrowserRouter>
    </ReactLenis>
  );
}
